// import React, { useEffect, useState, useMemo } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import "./customerDetail.css";
// import {
//   FiChevronRight,
//   FiArrowLeft,
//   FiMail,
//   FiPhone,
//   FiMapPin,
//   FiUser,
//   FiShoppingCart,
//   FiPackage,
//   FiFileText,
// } from "react-icons/fi";

// const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

// const formatDate = (isoString) => {
//   if (!isoString) return "-";
//   const date = new Date(isoString);
//   return date.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// const formatINR = (value) => {
//   if (value === null || value === undefined) return "₹0";
//   return new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 2,
//   }).format(value);
// };

// const getStatusClass = (status) => {
//   const s = (status || "").toLowerCase();
//   if (s === "processing") return "processing";
//   if (s === "shipped") return "shipped";
//   if (s === "delivered") return "delivered";
//   if (s === "cancelled") return "cancelled";
//   if (s === "pending") return "pending";
//   return "pending";
// };

// // Helper to get full image URL
// const getImageUrl = (imageUrl) => {
//   if (!imageUrl) return null;
//   // If it's already a full URL (Azure blob storage), return as is
//   if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
//     return imageUrl;
//   }
//   // If it's a relative path, prepend API base URL
//   return `${API_BASE_URL}${imageUrl}`;
// };

// const CustomerDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [panchayat, setPanchayat] = useState(null);
//   const [orders, setOrders] = useState([]);
//   const [orderStats, setOrderStats] = useState(null);
//   const [orderPagination, setOrderPagination] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [ordersLoading, setOrdersLoading] = useState(false);
//   const [serverError, setServerError] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [imageError, setImageError] = useState(false); // Track image loading errors

//   // Fetch panchayat details
//   useEffect(() => {
//     const fetchPanchayat = async () => {
//       try {
//         setLoading(true);
//         setServerError("");
//         setImageError(false); // Reset image error on new fetch

//         const res = await fetch(`${API_BASE_URL}/api/panchayaths/fetch/${id}`);
//         const data = await res.json();

//         console.log("GET /panchayaths/fetch/:id", res.status, data);

//         if (!res.ok || !data || data.success === false) {
//           setServerError(data?.message || data?.error || "Failed to load details.");
//           setPanchayat(null);
//           return;
//         }

//         setPanchayat(data.data);
//       } catch (err) {
//         console.error("Error fetching panchayat:", err);
//         setServerError("Unable to load details. Please try again.");
//         setPanchayat(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPanchayat();
//   }, [id]);

//   // Fetch orders for this panchayat
//   useEffect(() => {
//     const fetchOrders = async () => {
//       if (!id) return;

//       try {
//         setOrdersLoading(true);

//         const res = await fetch(
//           `${API_BASE_URL}/api/panchayaths/${id}/orders?page=${currentPage}&limit=10`
//         );
//         const data = await res.json();

//         console.log("GET /panchayaths/:id/orders", res.status, data);

//         if (res.ok && data.success) {
//           setOrders(data.data.orders || []);
//           setOrderStats(data.data.stats || null);
//           setOrderPagination(data.data.pagination || null);
//         }
//       } catch (err) {
//         console.error("Error fetching orders:", err);
//       } finally {
//         setOrdersLoading(false);
//       }
//     };

//     fetchOrders();
//   }, [id, currentPage]);

//   const address = useMemo(() => {
//     if (!panchayat) return "";
//     if (panchayat.address) return panchayat.address;
//     const parts = [
//       panchayat.name,
//       panchayat.taluk,
//       panchayat.district,
//       panchayat.pincode,
//       "Karnataka"
//     ];
//     return parts.filter(Boolean).join(", ");
//   }, [panchayat]);

//   const statusLabel = panchayat
//     ? (panchayat.status || "active").charAt(0).toUpperCase() +
//     (panchayat.status || "active").slice(1)
//     : "";

//   // Get the profile image URL
//   const profileImageUrl = useMemo(() => {
//     if (!panchayat) return null;
//     return getImageUrl(panchayat.imageUrl);
//   }, [panchayat]);

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= (orderPagination?.totalPages || 1)) {
//       setCurrentPage(page);
//     }
//   };

//   // Handle image load error
//   const handleImageError = () => {
//     setImageError(true);
//   };

//   if (loading) {
//     return (
//       <div className="cd-page">
//         <div className="cd-loading">Loading panchayat details...</div>
//       </div>
//     );
//   }

//   if (serverError || !panchayat) {
//     return (
//       <div className="cd-page">
//         <div className="cd-error">
//           <button
//             type="button"
//             className="cd-back-btn"
//             onClick={() => navigate(-1)}
//           >
//             <FiArrowLeft />
//             <span>Back</span>
//           </button>
//           <p>{serverError || "Panchayat not found."}</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="cd-page">
//       {/* HEADER */}
//       <div className="cd-header">
//         <div className="cd-header-left">
//           <button
//             type="button"
//             className="cd-back-btn"
//             onClick={() => navigate(-1)}
//           >
//             <FiArrowLeft />
//             <span>Back</span>
//           </button>

//           <h1 className="cd-title">Panchayat Details</h1>

//           <div className="cd-breadcrumbs">
//             <span className="breadcrumb-link">Dashboard</span>
//             <FiChevronRight className="breadcrumb-separator-icon" />
//             <span className="breadcrumb-link">Panchayat List</span>
//             <FiChevronRight className="breadcrumb-separator-icon" />
//             <span className="breadcrumb-current">Panchayat Details</span>
//           </div>
//         </div>
//       </div>

//       {/* MAIN LAYOUT */}
//       <div className="cd-layout">
//         {/* LEFT PROFILE CARD */}
//         <aside className="cd-profile-card">
//           <div className="cd-profile-header">
//             <div className="cd-cover" />
//             <div className="cd-avatar-wrapper">
//               {/* Show image if available and no error, otherwise show placeholder */}
//               {profileImageUrl && !imageError ? (
//                 <img
//                   src={profileImageUrl}
//                   alt={panchayat.name || "Panchayat"}
//                   className="cd-avatar-img"
//                   onError={handleImageError}
//                 />
//               ) : (
//                 <div className="cd-avatar-placeholder">
//                   {panchayat.name?.charAt(0)?.toUpperCase() || "P"}
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="cd-profile-body">
//             <div className="cd-profile-name-row">
//               <h2 className="cd-profile-name">{panchayat.name}</h2>
//               <span className={`cd-status-pill cd-status-${panchayat.status || 'active'}`}>
//                 {statusLabel}
//               </span>
//             </div>

//             <div className="cd-profile-info">
//               <div className="cd-info-item">
//                 <FiUser className="cd-info-icon" />
//                 <div className="cd-info-text">
//                   <span className="cd-info-label">Panchayat ID</span>
//                   <span className="cd-info-value">
//                     ID-{String(panchayat.id).padStart(6, "0")}
//                   </span>
//                 </div>
//               </div>

//               <div className="cd-info-item">
//                 <FiMail className="cd-info-icon" />
//                 <div className="cd-info-text">
//                   <span className="cd-info-label">Email</span>
//                   <span className="cd-info-value">{panchayat.email || "-"}</span>
//                 </div>
//               </div>

//               <div className="cd-info-item">
//                 <FiPhone className="cd-info-icon" />
//                 <div className="cd-info-text">
//                   <span className="cd-info-label">Phone Number</span>
//                   <span className="cd-info-value">{panchayat.phoneNumber || "-"}</span>
//                 </div>
//               </div>

//               <div className="cd-info-item">
//                 <FiMapPin className="cd-info-icon" />
//                 <div className="cd-info-text">
//                   <span className="cd-info-label">Location</span>
//                   <span className="cd-info-value">
//                     {panchayat.taluk}, {panchayat.district}
//                   </span>
//                 </div>
//               </div>

//               <div className="cd-info-item">
//                 <FiMapPin className="cd-info-icon" />
//                 <div className="cd-info-text">
//                   <span className="cd-info-label">Address</span>
//                   <span className="cd-info-value">{address || "-"}</span>
//                 </div>
//               </div>

//               {panchayat.pincode && (
//                 <div className="cd-info-item">
//                   <FiMapPin className="cd-info-icon" />
//                   <div className="cd-info-text">
//                     <span className="cd-info-label">Pincode</span>
//                     <span className="cd-info-value">{panchayat.pincode}</span>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </aside>

//         {/* RIGHT SIDE: SUMMARY + ORDERS */}
//         <main className="cd-main">
//           {/* SUMMARY CARDS */}
//           <div className="cd-summary-grid">
//             <div className="cd-summary-card cd-summary-card-note">
//               <div className="cd-summary-icon">
//                 <FiShoppingCart />
//               </div>
//               <div className="cd-summary-content">
//                 <div className="cd-summary-label">Total Orders</div>
//                 <div className="cd-summary-value">
//                   {panchayat.orderCount || orderStats?.totalOrders || 0}
//                 </div>
//               </div>
//             </div>

//             <div className="cd-summary-card cd-summary-card-note">
//               <div className="cd-summary-icon">
//                 <FiPackage />
//               </div>
//               <div className="cd-summary-content">
//                 <div className="cd-summary-label">Total Order Amount</div>
//                 <div className="cd-summary-value">
//                   {formatINR(panchayat.totalOrderAmount || orderStats?.totalAmount || 0)}
//                 </div>
//               </div>
//             </div>

//             {/* Note + Dairy Row */}
//             <div className="cd-summary-row">
//               {/* Customer Note */}
//               <div className="cd-summary-card cd-summary-card-note">
//                 <div className="cd-summary-icon">
//                   <FiFileText />
//                 </div>
//                 <div className="cd-summary-content">
//                   <div className="cd-summary-label">Customer Note</div>
//                   <div className="cd-summary-note">
//                     {panchayat.note || "No notes added"}
//                   </div>
//                 </div>
//               </div>

//               {/* Dairy */}
//               <div className="cd-summary-card cd-summary-card-note">
//                 <div className="cd-summary-icon">
//                   <FiFileText />
//                 </div>
//                 <div className="cd-summary-content">
//                   <div className="cd-summary-label">Dairy</div>
//                   <div className="cd-summary-note">
//                     {panchayat.dairy || "No dairy details"}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ORDER STATS */}
//           {orderStats && (
//             <div className="cd-order-stats">
//               <div className="cd-stat-item">
//                 <span className="cd-stat-label">Pending:</span>
//                 <span className="cd-stat-value cd-stat-pending">
//                   {orderStats.pending || 0}
//                 </span>
//               </div>
//               <div className="cd-stat-item">
//                 <span className="cd-stat-label">Delivered:</span>
//                 <span className="cd-stat-value cd-stat-delivered">
//                   {orderStats.delivered || 0}
//                 </span>
//               </div>
//             </div>
//           )}

//           {/* ORDER HISTORY */}
//           <section className="cd-transactions-card">
//             <div className="cd-transactions-header">
//               <h2 className="cd-transactions-title">Order History</h2>
//             </div>

//             {ordersLoading ? (
//               <div className="cd-loading">Loading orders...</div>
//             ) : orders.length === 0 ? (
//               <div className="cd-empty-orders">
//                 <FiShoppingCart size={48} />
//                 <p>No orders found for this panchayat</p>
//               </div>
//             ) : (
//               <>
//                 <div className="cd-transactions-table-wrapper">
//                   <table className="cd-transactions-table">
//                     <thead>
//                       <tr>
//                         <th>Order ID</th>
//                         <th>Product</th>
//                         <th>Items</th>
//                         <th>Total</th>
//                         <th>Status</th>
//                         <th>Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {orders.map((order) => (
//                         <tr key={order.orderId}>
//                           <td className="cd-tx-order-id">
//                             <span className="cd-order-id-text">
//                               {order.orderNumber}
//                             </span>
//                           </td>
//                           <td className="cd-tx-product">
//                             <div className="cd-tx-product-main">
//                               <div className="cd-tx-product-avatar">
//                                 <FiPackage />
//                               </div>
//                               <div>
//                                 <div className="cd-tx-product-title">
//                                   {order.firstProductName || "Product"}
//                                 </div>
//                                 {order.itemsCount > 1 && (
//                                   <div className="cd-tx-product-sub">
//                                     +{order.itemsCount - 1} more item{order.itemsCount > 2 ? 's' : ''}
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="cd-tx-items">
//                             {order.itemsCount}
//                           </td>
//                           <td className="cd-tx-total">
//                             {formatINR(order.totalAmount)}
//                           </td>
//                           <td className="cd-tx-status">
//                             <span className={`cd-status-pill cd-status-${getStatusClass(order.orderStatus)}`}>
//                               {order.orderStatus}
//                             </span>
//                           </td>
//                           <td className="cd-tx-date">
//                             {formatDate(order.createdAt)}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 {/* PAGINATION */}
//                 {orderPagination && orderPagination.totalPages > 1 && (
//                   <div className="cd-transactions-footer">
//                     <span>
//                       Showing {((currentPage - 1) * 10) + 1}-
//                       {Math.min(currentPage * 10, orderPagination.total)} of {orderPagination.total}
//                     </span>
//                     <div className="cd-pagination">
//                       <button
//                         type="button"
//                         className="cd-page-btn"
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                       >
//                         ‹
//                       </button>
//                       {Array.from({ length: Math.min(5, orderPagination.totalPages) }, (_, i) => {
//                         let page = i + 1;
//                         return (
//                           <button
//                             key={page}
//                             type="button"
//                             className={`cd-page-btn ${currentPage === page ? 'active' : ''}`}
//                             onClick={() => handlePageChange(page)}
//                           >
//                             {page}
//                           </button>
//                         );
//                       })}
//                       <button
//                         type="button"
//                         className="cd-page-btn"
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === orderPagination.totalPages}
//                       >
//                         ›
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//           </section>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default CustomerDetail;


import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./customerDetail.css";
import {
  FiChevronRight,
  FiArrowLeft,
  FiMail,
  FiPhone,
  FiMapPin,
  FiUser,
  FiShoppingCart,
  FiPackage,
  FiFileText,
  FiDollarSign,
  FiPlusCircle,
  FiEdit2,
  FiCheck,
  FiEdit3,
  
  FiX,
} from "react-icons/fi";

const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

const formatDate = (isoString) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatINR = (value) => {
  if (value === null || value === undefined) return "₹0";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(value);
};

const getStatusClass = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "processing") return "processing";
  if (s === "shipped") return "shipped";
  if (s === "delivered") return "delivered";
  if (s === "cancelled") return "cancelled";
  if (s === "pending") return "pending";
  if (s === "packed") return "packed";
  return "pending";
};

const getImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) {
    return imageUrl;
  }
  return `${API_BASE_URL}${imageUrl}`;
};

// Toast Component
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`cd-toast cd-toast-${type}`}>
      <span>{message}</span>
      <button onClick={onClose}>×</button>
    </div>
  );
};

const CustomerDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [panchayat, setPanchayat] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderStats, setOrderStats] = useState(null);
  const [orderPagination, setOrderPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [imageError, setImageError] = useState(false);

  // Custom amount editing state
  const [isEditingCustomAmount, setIsEditingCustomAmount] = useState(false);
  const [customAmountInput, setCustomAmountInput] = useState("");
  const [savingCustomAmount, setSavingCustomAmount] = useState(false);
  const [customAmountError, setCustomAmountError] = useState("");
  const [customAmountMode, setCustomAmountMode] = useState("add");
  // Toast state
  const [toast, setToast] = useState(null);

  // Show toast helper
  const showToast = useCallback((message, type = "success") => {
    setToast({ message, type });
  }, []);

  // Fetch panchayat details
  useEffect(() => {
    const fetchPanchayat = async () => {
      try {
        setLoading(true);
        setServerError("");
        setImageError(false);

        const res = await fetch(`${API_BASE_URL}/api/panchayaths/fetch/${id}`);
        const data = await res.json();

        console.log("GET /panchayaths/fetch/:id", res.status, data);

        if (!res.ok || !data || data.success === false) {
          setServerError(data?.message || data?.error || "Failed to load details.");
          setPanchayat(null);
          return;
        }

        setPanchayat(data.data);
        setCustomAmountInput(String(data.data.customAmount || 0));
      } catch (err) {
        console.error("Error fetching panchayat:", err);
        setServerError("Unable to load details. Please try again.");
        setPanchayat(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPanchayat();
  }, [id]);

  // Fetch orders for this panchayat
  useEffect(() => {
    const fetchOrders = async () => {
      if (!id) return;

      try {
        setOrdersLoading(true);

        const res = await fetch(
          `${API_BASE_URL}/api/panchayaths/${id}/orders?page=${currentPage}&limit=10`
        );
        const data = await res.json();

        console.log("GET /panchayaths/:id/orders", res.status, data);

        if (res.ok && data.success) {
          setOrders(data.data.orders || []);
          setOrderStats(data.data.stats || null);
          setOrderPagination(data.data.pagination || null);
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchOrders();
  }, [id, currentPage]);

  // Custom amount handlers
  // const handleStartEditCustomAmount = () => {
  //   setCustomAmountInput(String(panchayat?.customAmount || 0));
  //   setIsEditingCustomAmount(true);
  //   setCustomAmountError("");
  // };

 const handleStartEditCustomAmount = () => {
  setCustomAmountInput("");
  setCustomAmountMode("add"); // Default to add
  setIsEditingCustomAmount(true);
  setCustomAmountError("");
};

  // const handleCancelEditCustomAmount = () => {
  //   setIsEditingCustomAmount(false);
  //   setCustomAmountInput(String(panchayat?.customAmount || 0));
  //   setCustomAmountError("");
  // };

  const handleCancelEditCustomAmount = () => {
  setIsEditingCustomAmount(false);
  setCustomAmountInput("");
  setCustomAmountMode("add");
  setCustomAmountError("");
};

 

// const handleSaveCustomAmount = async () => {
//   const inputAmount = parseFloat(customAmountInput);

//   if (isNaN(inputAmount) || inputAmount <= 0) {
//     setCustomAmountError("Please enter an amount greater than 0");
//     return;
//   }

//   // ✅ Calculate actual amount based on mode
//   const amount = customAmountMode === "subtract" ? -inputAmount : inputAmount;

//   // ✅ Prevent subtracting more than current balance
//   if (customAmountMode === "subtract" && inputAmount > customAmount) {
//     setCustomAmountError(`Cannot subtract more than current balance (${formatINR(customAmount)})`);
//     return;
//   }

//   setSavingCustomAmount(true);
//   setCustomAmountError("");

//   try {
//     const res = await fetch(`${API_BASE_URL}/api/panchayaths/${id}/custom-amount`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ custom_amount: amount }),
//     });

//     const data = await res.json();

//     if (!res.ok || !data.success) {
//       throw new Error(data.message || "Failed to update amount");
//     }

//     setPanchayat({ ...data.data });
//     setCustomAmountInput("");
//     setCustomAmountMode("add");
//     setIsEditingCustomAmount(false);
    
//     // ✅ Dynamic success message
//     const action = customAmountMode === "subtract" ? "subtracted" : "added";
//     showToast(`₹${inputAmount.toLocaleString('en-IN')} ${action} successfully!`, "success");
    
//   } catch (err) {
//     console.error("Error saving custom amount:", err);
//     setCustomAmountError(err.message || "Failed to save");
//     showToast(err.message || "Failed to update amount", "error");
//   } finally {
//     setSavingCustomAmount(false);
//   }
// };


const handleSaveCustomAmount = async () => {
  const inputAmount = parseFloat(customAmountInput);

  if (isNaN(inputAmount) || inputAmount <= 0) {
    setCustomAmountError("Please enter an amount greater than 0");
    return;
  }

  // ✅ Calculate actual amount based on mode
  const amount = customAmountMode === "subtract" ? -inputAmount : inputAmount;

  // ✅ REMOVED: No more balance check
  // if (customAmountMode === "subtract" && inputAmount > customAmount) {
  //   setCustomAmountError(`Cannot subtract more than current balance`);
  //   return;
  // }

  setSavingCustomAmount(true);
  setCustomAmountError("");

  console.log("Sending amount:", amount, "Mode:", customAmountMode);

  try {
    const res = await fetch(`${API_BASE_URL}/api/panchayaths/${id}/custom-amount`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ custom_amount: amount }),
    });

    const data = await res.json();
    console.log("Response:", data);

    if (!res.ok || !data.success) {
      throw new Error(data.message || "Failed to update amount");
    }

    setPanchayat({ ...data.data });
    setCustomAmountInput("");
    setCustomAmountMode("add");
    setIsEditingCustomAmount(false);
    
    const action = customAmountMode === "subtract" ? "subtracted" : "added";
    showToast(`₹${inputAmount.toLocaleString('en-IN')} ${action} successfully!`, "success");
    
  } catch (err) {
    console.error("Error saving custom amount:", err);
    setCustomAmountError(err.message || "Failed to save");
    showToast(err.message || "Failed to update amount", "error");
  } finally {
    setSavingCustomAmount(false);
  }
};

  const handleCustomAmountKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSaveCustomAmount();
    } else if (e.key === "Escape") {
      handleCancelEditCustomAmount();
    }
  };

  const address = useMemo(() => {
    if (!panchayat) return "";
    if (panchayat.address) return panchayat.address;
    const parts = [
      panchayat.name,
      panchayat.taluk,
      panchayat.district,
      panchayat.pincode,
      "Karnataka"
    ];
    return parts.filter(Boolean).join(", ");
  }, [panchayat]);

  const statusLabel = panchayat
    ? (panchayat.status || "active").charAt(0).toUpperCase() +
    (panchayat.status || "active").slice(1)
    : "";

  const profileImageUrl = useMemo(() => {
    if (!panchayat) return null;
    return getImageUrl(panchayat.imageUrl);
  }, [panchayat]);

  // Calculate totals
  const totalOrderAmount = useMemo(() => {
    return panchayat?.totalOrderAmount || orderStats?.totalAmount || 0;
  }, [panchayat, orderStats]);

  const customAmount = useMemo(() => {
    return panchayat?.customAmount || 0;
  }, [panchayat]);

  const grandTotal = useMemo(() => {
    if (panchayat?.grandTotal !== undefined) return panchayat.grandTotal;
    return Number(totalOrderAmount) + Number(customAmount);
  }, [panchayat, totalOrderAmount, customAmount]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= (orderPagination?.totalPages || 1)) {
      setCurrentPage(page);
    }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  if (loading) {
    return (
      <div className="cd-page">
        <div className="cd-loading">Loading panchayat details...</div>
      </div>
    );
  }

  if (serverError || !panchayat) {
    return (
      <div className="cd-page">
        <div className="cd-error">
          <button
            type="button"
            className="cd-back-btn"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
            <span>Back</span>
          </button>
          <p>{serverError || "Panchayat not found."}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cd-page">
      {/* Toast */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* HEADER */}
      <div className="cd-header">
        <div className="cd-header-left">
          <button
            type="button"
            className="cd-back-btn"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
            <span>Back</span>
          </button>

          <h1 className="cd-title">Panchayat Details</h1>

          <div className="cd-breadcrumbs">
            <span className="breadcrumb-link">Dashboard</span>
            <FiChevronRight className="breadcrumb-separator-icon" />
            <span className="breadcrumb-link">Panchayat List</span>
            <FiChevronRight className="breadcrumb-separator-icon" />
            <span className="breadcrumb-current">Panchayat Details</span>
          </div>
        </div>
      </div>

      {/* MAIN LAYOUT */}
      <div className="cd-layout">
        {/* LEFT PROFILE CARD */}
        <aside className="cd-profile-card">
          <div className="cd-profile-header">
            <div className="cd-cover" />
            <div className="cd-avatar-wrapper">
              {profileImageUrl && !imageError ? (
                <img
                  src={profileImageUrl}
                  alt={panchayat.name || "Panchayat"}
                  className="cd-avatar-img"
                  onError={handleImageError}
                />
              ) : (
                <div className="cd-avatar-placeholder">
                  {panchayat.name?.charAt(0)?.toUpperCase() || "P"}
                </div>
              )}
            </div>
          </div>

          <div className="cd-profile-body">
            <div className="cd-profile-name-row">
              <h2 className="cd-profile-name">{panchayat.name}</h2>
              <span className={`cd-status-pill cd-status-${panchayat.status || 'active'}`}>
                {statusLabel}
              </span>
            </div>

            <div className="cd-profile-info">
              <div className="cd-info-item">
                <FiUser className="cd-info-icon" />
                <div className="cd-info-text">
                  <span className="cd-info-label">Panchayat ID</span>
                  <span className="cd-info-value">
                    ID-{String(panchayat.id).padStart(6, "0")}
                  </span>
                </div>
              </div>

              <div className="cd-info-item">
                <FiMail className="cd-info-icon" />
                <div className="cd-info-text">
                  <span className="cd-info-label">Email</span>
                  <span className="cd-info-value">{panchayat.email || "-"}</span>
                </div>
              </div>

              <div className="cd-info-item">
                <FiPhone className="cd-info-icon" />
                <div className="cd-info-text">
                  <span className="cd-info-label">Phone Number</span>
                  <span className="cd-info-value">{panchayat.phoneNumber || "-"}</span>
                </div>
              </div>

              <div className="cd-info-item">
                <FiMapPin className="cd-info-icon" />
                <div className="cd-info-text">
                  <span className="cd-info-label">Location</span>
                  <span className="cd-info-value">
                    {panchayat.taluk}, {panchayat.district}
                  </span>
                </div>
              </div>

              <div className="cd-info-item">
                <FiMapPin className="cd-info-icon" />
                <div className="cd-info-text">
                  <span className="cd-info-label">Address</span>
                  <span className="cd-info-value">{address || "-"}</span>
                </div>
              </div>

              {panchayat.pincode && (
                <div className="cd-info-item">
                  <FiMapPin className="cd-info-icon" />
                  <div className="cd-info-text">
                    <span className="cd-info-label">Pincode</span>
                    <span className="cd-info-value">{panchayat.pincode}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </aside>

        {/* RIGHT SIDE: SUMMARY + ORDERS */}
        <main className="cd-main">
          {/* SUMMARY CARDS */}
          <div className="cd-summary-grid">
            {/* Row 1: Total Orders | Total Order Amount | Custom Amount */}
            <div className="cd-summary-row cd-summary-row-3">
              {/* Total Orders */}
              <div className="cd-summary-card">
                <div className="cd-summary-icon">
                  <FiShoppingCart />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label">Total Orders</div>
                  <div className="cd-summary-value">
                    {panchayat.orderCount || orderStats?.totalOrders || 0}
                  </div>
                </div>
              </div>

              {/* Total Order Amount */}
              <div className="cd-summary-card">
                <div className="cd-summary-icon">
                  <FiPackage />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label">Total Order Amount</div>
                  <div className="cd-summary-value">
                    {formatINR(totalOrderAmount)}
                  </div>
                </div>
              </div>

              {/* Custom Amount - EDITABLE */}
              {/* <div className="cd-summary-card cd-summary-card-custom">
                <div className="cd-summary-icon cd-icon-custom">
                  <FiPlusCircle />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label-row">
                    <span className="cd-summary-label">Custom Balance</span>
                    {!isEditingCustomAmount && (
                      <button
                        type="button"
                        className="cd-card-edit-btn"
                        onClick={handleStartEditCustomAmount}
                        title="Edit custom balance"
                      >
                        <FiEdit2 size={14} />
                      </button>
                    )}
                  </div>

                  {isEditingCustomAmount ? (
                    <div className="cd-custom-edit-wrapper">
                      <div className="cd-custom-input-group">
                        <span className="cd-input-prefix">₹</span>
                        <input
                          type="number"
                          className="cd-custom-amount-input"
                          value={customAmountInput}
                          onChange={(e) => setCustomAmountInput(e.target.value)}
                          onKeyDown={handleCustomAmountKeyDown}
                          placeholder="0.00"
                          min="0"
                          step="0.01"
                          disabled={savingCustomAmount}
                          autoFocus
                        />
                      </div>
                      <div className="cd-custom-edit-actions">
                        <button
                          type="button"
                          className="cd-action-btn cd-action-save"
                          onClick={handleSaveCustomAmount}
                          disabled={savingCustomAmount}
                          title="Save"
                        >
                          {savingCustomAmount ? (
                            <span className="cd-spinner-small" />
                          ) : (
                            <FiCheck size={16} />
                          )}
                        </button>
                        <button
                          type="button"
                          className="cd-action-btn cd-action-cancel"
                          onClick={handleCancelEditCustomAmount}
                          disabled={savingCustomAmount}
                          title="Cancel"
                        >
                          <FiX size={16} />
                        </button>
                      </div>
                      {customAmountError && (
                        <div className="cd-custom-error">{customAmountError}</div>
                      )}
                    </div>
                  ) : (
                    <div className="cd-summary-value cd-value-custom">
                      {formatINR(customAmount)}
                    </div>
                  )}
                </div>
              </div> */}


{/* Custom Balance - Add/Subtract Amount */}
<div className="cd-summary-card cd-summary-card-custom">
  <div className="cd-summary-icon cd-icon-custom">
    <FiPlusCircle />
  </div>
  <div className="cd-summary-content">
    <div className="cd-summary-label-row">
      <span className="cd-summary-label">Custom Balance</span>
      {!isEditingCustomAmount && (
        <button
          type="button"
          className="cd-card-edit-btn"
          onClick={handleStartEditCustomAmount}
          title="Add or subtract amount"
        >
          <FiEdit2 size={14} />
        </button>
      )}
    </div>

    {isEditingCustomAmount ? (
      <div className="cd-custom-edit-wrapper">
        {/* ✅ Mode Toggle Buttons */}
        <div className="cd-mode-toggle">
          <button
            type="button"
            className={`cd-mode-btn ${customAmountMode === "add" ? "active add" : ""}`}
            onClick={() => setCustomAmountMode("add")}
            disabled={savingCustomAmount}
          >
            + Add
          </button>
          <button
            type="button"
            className={`cd-mode-btn ${customAmountMode === "subtract" ? "active subtract" : ""}`}
            onClick={() => setCustomAmountMode("subtract")}
            disabled={savingCustomAmount}
          >
            − Subtract
          </button>
        </div>

        {/* Amount Input */}
        <div className="cd-custom-input-group">
          <span className={`cd-input-prefix ${customAmountMode === "subtract" ? "subtract" : "add"}`}>
            {customAmountMode === "subtract" ? "−₹" : "+₹"}
          </span>
          <input
            type="number"
            className="cd-custom-amount-input"
            value={customAmountInput}
            onChange={(e) => setCustomAmountInput(e.target.value)}
            onKeyDown={handleCustomAmountKeyDown}
            placeholder="Enter amount"
            min="0"
            step="0.01"
            disabled={savingCustomAmount}
            autoFocus
          />
        </div>

        {/* Action Buttons */}
        <div className="cd-custom-edit-actions">
          <button
            type="button"
            className={`cd-action-btn ${customAmountMode === "subtract" ? "cd-action-subtract" : "cd-action-save"}`}
            onClick={handleSaveCustomAmount}
            disabled={savingCustomAmount}
            title={customAmountMode === "subtract" ? "Subtract" : "Add"}
          >
            {savingCustomAmount ? (
              <span className="cd-spinner-small" />
            ) : (
              <FiCheck size={16} />
            )}
          </button>
          <button
            type="button"
            className="cd-action-btn cd-action-cancel"
            onClick={handleCancelEditCustomAmount}
            disabled={savingCustomAmount}
            title="Cancel"
          >
            <FiX size={16} />
          </button>
        </div>

        {/* Error Message */}
        {customAmountError && (
          <div className="cd-custom-error">{customAmountError}</div>
        )}

        {/* Current Balance Hint */}
        <div className="cd-custom-hint">
          Current balance: {formatINR(customAmount)}
        </div>
      </div>
    ) : (
      <div className="cd-summary-value cd-value-custom">
        {formatINR(customAmount)}
      </div>
    )}
  </div>
</div>

              
            </div>

            {/* Row 2: Customer Note | Dairy | Grand Total */}
            <div className="cd-summary-row cd-summary-row-3">
              {/* Customer Note */}
              <div className="cd-summary-card cd-summary-card-note">
                <div className="cd-summary-icon">
                  <FiFileText />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label">Customer Note</div>
                  <div className="cd-summary-note">
                    {panchayat.note || "No notes added"}
                  </div>
                </div>
              </div>

              {/* Dairy */}
              <div className="cd-summary-card cd-summary-card-note">
                <div className="cd-summary-icon">
                  <FiFileText />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label">Dairy</div>
                  <div className="cd-summary-note">
                    {panchayat.dairy || "No dairy details"}
                  </div>
                </div>
              </div>

              {/* Grand Total */}
              <div className="cd-summary-card cd-summary-card-grand">
                <div className="cd-summary-icon cd-icon-grand">
                  <FiDollarSign />
                </div>
                <div className="cd-summary-content">
                  <div className="cd-summary-label">Grand Total</div>
                  <div className="cd-summary-value cd-value-grand">
                    {formatINR(grandTotal)}
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          {/* ORDER HISTORY */}
          <section className="cd-transactions-card">
            <div className="cd-transactions-header">
              <h2 className="cd-transactions-title">Order History</h2>
            </div>

            {ordersLoading ? (
              <div className="cd-loading">Loading orders...</div>
            ) : orders.length === 0 ? (
              <div className="cd-empty-orders">
                <FiShoppingCart size={48} />
                <p>No orders found for this panchayat</p>
              </div>
            ) : (
              <>
                <div className="cd-transactions-table-wrapper">
                  <table className="cd-transactions-table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Product</th>
                        <th>Items</th>
                        <th>Amount</th>
                        <th>Status</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orders.map((order) => (
                        <tr key={order.orderId}>
                          <td className="cd-tx-order-id">
                            <span className="cd-order-id-text">
                              {order.orderNumber}
                            </span>
                          </td>
                          <td className="cd-tx-product">
                            <div className="cd-tx-product-main">
                              <div className="cd-tx-product-avatar">
                                {order.firstProductImage ? (
                                  <img
                                    src={getImageUrl(order.firstProductImage)}
                                    alt=""
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                      if (e.target.nextSibling) {
                                        e.target.nextSibling.style.display = 'flex';
                                      }
                                    }}
                                  />
                                ) : null}
                                <div
                                  className="cd-product-icon-fallback"
                                  style={{ display: order.firstProductImage ? 'none' : 'flex' }}
                                >
                                  <FiPackage />
                                </div>
                              </div>
                              <div>
                                <div className="cd-tx-product-title">
                                  {order.firstProductName || "Product"}
                                </div>
                                {order.itemsCount > 1 && (
                                  <div className="cd-tx-product-sub">
                                    +{order.itemsCount - 1} more item{order.itemsCount > 2 ? 's' : ''}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="cd-tx-items">
                            {order.itemsCount}
                          </td>
                          <td className="cd-tx-total">
                            {formatINR(order.totalAmount)}
                          </td>
                          <td className="cd-tx-status">
                            <span className={`cd-status-pill cd-status-${getStatusClass(order.orderStatus)}`}>
                              {order.orderStatus}
                            </span>
                          </td>
                          <td className="cd-tx-date">
                            {formatDate(order.createdAt)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* PAGINATION */}
                {orderPagination && orderPagination.totalPages > 1 && (
                  <div className="cd-transactions-footer">
                    <span>
                      Showing {((currentPage - 1) * 10) + 1}-
                      {Math.min(currentPage * 10, orderPagination.total)} of {orderPagination.total}
                    </span>
                    <div className="cd-pagination">
                      <button
                        type="button"
                        className="cd-page-btn"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        ‹
                      </button>
                      {Array.from({ length: Math.min(5, orderPagination.totalPages) }, (_, i) => {
                        let page = i + 1;
                        return (
                          <button
                            key={page}
                            type="button"
                            className={`cd-page-btn ${currentPage === page ? 'active' : ''}`}
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </button>
                        );
                      })}
                      <button
                        type="button"
                        className="cd-page-btn"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === orderPagination.totalPages}
                      >
                        ›
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

export default CustomerDetail;